import { AppWrapper } from 'components/AppWrapper';
import { SurveyList } from 'components/SurveyList';

import { RewardSection } from './Aside';

export function Rewards() {
  return (
    <AppWrapper leftContent={<RewardSection />}>
      <SurveyList />
    </AppWrapper>
  );
}
